import { Component, OnInit } from '@angular/core';

import { langEN, langSK } from '../variables';
import { Languages } from '../languages';


@Component({
  selector: 'app-first-page',
  templateUrl: './first-page.component.html',
  styleUrls: ['./first-page.component.css']
})
export class FirstPageComponent implements OnInit {

  lang: Languages;

  shipNmrFromInput:string;

  constructor() { }

  ngOnInit(): void {
    // this.lang = langSK
  }

  shipNmrToChild(input: string) { // aby ulozil nove data a tym poslal do child componentu
    this.shipNmrFromInput = input;
  }

  selectLanguageSK () {
    this.lang = langSK
  }

  selectLanguageEN () {
    this.lang = langEN
  }

  switchLang (input:Languages) {
    this.lang = input
  }

}